import Cookies from 'universal-cookie';
import { defaultLng } from './i18n';
import { isEmpty, jwtDecode } from './helpers';
import { ACCESS_TOKEN, DJANGO_LANGUAGE, REFRESH_TOKEN } from '@/configs';

let refreshingToken = false;
export const clientFetch = async (
  path,
  { headers = {}, fileUpload, isPage, query, ...options } = {}
) =>
  new Promise(async (resolve, reject) => {
    // const url = 'https://dev.holdyou.net/api' + path;
    let url =
      (path || '').indexOf('://') > -1
        ? path
        : `${process.env.REACT_APP_API_URL}${path}`;
    const cookies = new Cookies();
    let accessToken = cookies.get(ACCESS_TOKEN);
    let refreshToken = cookies.get(REFRESH_TOKEN);
    let langFromCookie = cookies.get(DJANGO_LANGUAGE);

    const allHeaders = {
      Accept: 'application/json',
      ...headers,
    };

    if (!fileUpload) allHeaders['Content-Type'] = 'application/json';
    // if (fileUpload) allHeaders['Content-Type'] = 'multipart/form-data';
    if (langFromCookie) {
      allHeaders['Accept-Language'] = langFromCookie || defaultLng;
    }
    if (accessToken) {
      allHeaders['Authorization'] = `Bearer ${accessToken}`;
    }

    if (accessToken && !refreshingToken) {
      const jwtDecoded = jwtDecode(accessToken);
      if (!!jwtDecoded) {
        if (Date.now() + 180 >= jwtDecoded.exp * 1000) {
          refreshingToken = true;
          const response = await fetch('/api/users/token/refresh', {
            headers: allHeaders,
            method: 'POST',
            body: JSON.stringify({ refresh: refreshToken }),
          });
          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            if (response.ok) {
              const newTokens = await response.json();
              if (newTokens) {
                const jwtDecoded = jwtDecode(newTokens?.access);
                if (!!jwtDecoded) {
                  const cookieExpiresDate = new Date(jwtDecoded.exp * 1000);
                  cookies.set('access_token', newTokens?.access, {
                    path: '/',
                    expires: cookieExpiresDate,
                  });
                  cookies.set('refresh_token', newTokens?.refresh, {
                    path: '/',
                    expires: cookieExpiresDate,
                  });
                  accessToken = newTokens?.access;
                  if (accessToken) {
                    allHeaders['Authorization'] = `Bearer ${accessToken}`;
                  }
                }
              }
            }
          } else {
            console.log('Server error when fetch token refresh: 500');
          }
        }
        refreshingToken = false;
      }
    }

    if (!isEmpty(query)) {
      url += '?' + new URLSearchParams(query).toString();
    }

    return fetch(url, {
      headers: allHeaders,
      ...options,
    })
      .then(async (res) => {
        const contentType = res.headers.get('content-type');
        // console.group('::------------ clientFetch ------------::');
        // console.log('- url:', url);
        // console.log('- res:', res);
        // console.log('- res.status:', res.status);
        // console.log('- contentType:', contentType);
        // console.log('- cookies.getAll()', cookies.getAll());
        // console.log('=======================================');
        // console.groupEnd();

        if (res.status === 204) {
          return Promise.resolve({});
        }
        if (res.ok) {
          if (res.statusText !== 'No Content') {
            return await res.json();
          }
          return Promise.resolve({});
        }
        if (res.status === 401) {
          if (accessToken) {
            cookies.remove('access_token', { path: '/' });
            cookies.remove('refresh_token', { path: '/' });
          }
          return Promise.reject({
            message: 'Authentificate error',
            errors: await res.json(),
            status: res.status,
          });
        } else if (res.status === 404) {
          return Promise.reject({
            message: 'Page not found',
            errors: {},
            status: res.status,
          });
        } else if (
          res.status !== 204 &&
          (!contentType || !contentType.includes('application/json'))
        ) {
          return Promise.reject({
            message: 'Ошибка на сервере. JSON!',
            status: 500,
          });
        } else {
          return Promise.reject({
            errors: await res.json(),
            status: res.status,
          });
        }
      })
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject({ ...error });
      });
  });
